<template>
  <client-only>
    <div v-show="isCuntryCookie && !isApp" class="cookie-center">
      <div v-if="!isDesktop" class="cookie-center-mobile">
        <div v-show="showCookiePopup" class="placeholder"></div>
        <van-action-sheet
          :lock-scroll="false"
          :class="['tips-model-mobile', isTurbo ? 'tips-model-mobile-gt' : '']"
          :overlay="false"
          :close-on-click-overlay="false"
          v-model="showCookiePopup"
          title=""
        >
          <div class="tips-action-sheet">
            <div class="content">
              {{ $t('cookie-privacy.content') }}
            </div>
            <div class="option-info">
              {{ $t('cookie-privacy.option_info') }}
              <span @click="onCookieHandlePolicyUrl">{{
                $t('cookie-privacy.see_more')
              }}</span>
            </div>
            <div class="cookie-buttons">
              <van-button
                block
                plain
                round
                type="primary"
                color="#F96000"
                class="tips-button"
                @click="settingModel = true"
                >{{
                  $t('cookie-privacy.cookie_buttons.btn_settings')
                }}</van-button
              >
              <van-button
                block
                round
                type="primary"
                color="#F96000"
                class="tips-button"
                @click="onAcceptAll"
                >{{
                  $t('cookie-privacy.cookie_buttons.btn_accept')
                }}</van-button
              >
            </div>
          </div>
        </van-action-sheet>
        <van-action-sheet
          :lock-scroll="false"
          :close-on-click-overlay="false"
          v-model="settingModel"
          :overlay="false"
          title=""
          :class="[
            'settings-layer-mobile',
            isTurbo ? 'settings-layer-mobile-gt' : '',
          ]"
        >
          <div class="settings-layer-title">
            {{ $t('cookie-privacy.cookie_buttons.btn_settings')
            }}<van-icon
              @click="settingModel = false"
              size="20"
              class="cross-icon"
              name="cross"
            />
          </div>
          <div :class="['tips-action-sheet', 'settings-layer']">
            <!-- scollView start-->
            <div class="cookie-centent-roll">
              <div class="content">
                {{ $t('cookie-privacy.cookie_settings_content') }}
              </div>
              <div class="option-info">
                {{ $t('cookie-privacy.cookie_settings_info') }}
                <span @click="onCookieHandlePolicyUrl">{{
                  $t('cookie-privacy.cookie_buttons.btn_policy')
                }}</span>
              </div>
              <template v-if="filterCookieList.length">
                <div
                  class="cookie-option-action"
                  v-for="item in filterCookieList"
                  :key="item.type"
                >
                  <div class="title">
                    <h2>{{ settingsLayerTitleMsg(item.type) }}</h2>
                    <div class="cookie-switch" v-if="!item.allow">
                      <van-switch
                        active-color="#05C575"
                        size="26"
                        v-model="item.switchModel"
                      />
                    </div>
                    <div class="cookie-mandatory" v-else>
                      {{ $t('cookie-privacy.cookie_settings_required_active') }}
                    </div>
                  </div>
                  <p>{{ settingsLayerDescMsg(item.type) }}</p>
                </div>
              </template>
            </div>
            <!-- scollView end-->
            <div class="cookie-buttons">
              <van-button
                block
                plain
                round
                type="primary"
                color="#F96000"
                class="tips-button"
                @click="onCommitPreferences"
                >{{
                  $t('cookie-privacy.cookie_buttons.btn_preference')
                }}</van-button
              >
              <van-button
                block
                round
                type="primary"
                color="#F96000"
                class="tips-button"
                @click="onAcceptAll"
                >{{
                  $t('cookie-privacy.cookie_buttons.btn_accept')
                }}</van-button
              >
              <van-button
                block
                round
                type="primary"
                color="#F96000"
                class="tips-button"
                @click="onRejectAll"
                >{{
                  $t('cookie-privacy.cookie_buttons.btn_decline')
                }}</van-button
              >
            </div>
          </div>
        </van-action-sheet>
      </div>
      <div v-else class="cookie-center-pc">
        <van-overlay :show="showCookiePopup">
          <div class="tips-action-sheet">
            <div class="content">
              {{ $t('cookie-privacy.content') }}
            </div>
            <div class="option-info">
              {{ $t('cookie-privacy.option_info')
              }}<span @click="onCookieHandlePolicyUrl">{{
                $t('cookie-privacy.see_more')
              }}</span>
            </div>
            <div class="cookie-buttons flex-col-center">
              <div class="tips-button" @click="settingModel = true">
                {{ $t('cookie-privacy.cookie_buttons.btn_settings') }}
              </div>
              <div class="tips-button" @click="onAcceptAll">
                {{ $t('cookie-privacy.cookie_buttons.btn_accept') }}
              </div>
            </div>
          </div>
        </van-overlay>
        <van-overlay :show="settingModel">
          <div class="tips-action-sheet settings-layer">
            <div class="settings-layer-title">
              {{ $t('cookie-privacy.cookie_buttons.btn_settings') }}
            </div>
            <div class="cookie-centent-roll">
              <div class="content">
                {{ $t('cookie-privacy.cookie_settings_content') }}
              </div>
              <div class="option-info" style="width: 100%">
                {{ $t('cookie-privacy.cookie_settings_info') }}
                <span @click="onCookieHandlePolicyUrl">{{
                  $t('cookie-privacy.cookie_buttons.btn_policy')
                }}</span>
              </div>
              <div class="cookie-option-action-list">
                <template v-if="filterCookieList.length">
                  <div
                    class="cookie-option-action"
                    v-for="item in filterCookieList"
                    :key="item.type"
                  >
                    <div class="title">
                      <h2>{{ settingsLayerTitleMsg(item.type) }}</h2>
                      <div class="cookie-switch" v-if="!item.allow">
                        <van-switch
                          active-color="#05C575"
                          size="26"
                          v-model="item.switchModel"
                        />
                      </div>
                      <div class="cookie-mandatory" v-else>
                        {{
                          $t('cookie-privacy.cookie_settings_required_active')
                        }}
                      </div>
                    </div>
                    <p>{{ settingsLayerDescMsg(item.type) }}</p>
                  </div>
                </template>
              </div>
            </div>
            <div class="cookie-buttons">
              <div class="tips-button" @click="onCommitPreferences">
                {{ $t('cookie-privacy.cookie_buttons.btn_preference') }}
              </div>
              <div class="tips-button" @click="onAcceptAll">
                {{ $t('cookie-privacy.cookie_buttons.btn_accept') }}
              </div>
              <div class="tips-button" @click="onRejectAll">
                {{ $t('cookie-privacy.cookie_buttons.btn_decline') }}
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
  </client-only>
</template>
<script>
  import Vue from 'vue'
  import { Switch, ActionSheet } from 'vant'
  import { mapState, mapMutations } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import { defaultCookieList } from './consts'
  import {
    cookieArrs,
    setCookieState,
    getCookieState,
    removeCookieState,
    cookieExpiresTime,
    initCuntryCookieState,
    dynamicLoadingSDK,
  } from '@/utils/cookieUtils'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { jumpToPage } from '@/utils/utils'

  const _defaultCookieList = cloneDeep(defaultCookieList)

  Vue.use(Switch)
  Vue.use(ActionSheet)

  const popup_id = 'cookie-popup'

  export default {
    name: 'cookie-action-sheete',
    props: {
      cookieList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        filterCookieList: [], // 渲染的cookie 功能列表
        isLayerNumber: 0, // 记录那个弹层弹出 1=> 默认弹层； 2 => settingModel弹层
        tipsModel: false, // 设置初始化cookie弹层状态
        settingModel: false, // 设置cookie Settings 弹层状态
        showCookiePopup: false,
      }
    },
    computed: {
      ...mapState([
        'openCookies',
        'isTurbo',
        'isDesktop',
        'isCuntryCookie',
        'isApp',
      ]),
    },
    watch: {
      tipsModel(val) {
        if (this.isApp) {
          return
        }
        if (val) {
          PQ.enqueue({
            id: popup_id,
            priority: 2,
          })
        }
      },
      $route(newVal) {
        const { name } = newVal

        if (name && name === 'cookiePolicy') {
          this.tipsModel = false
          this.settingModel = false
        } else {
          const cookieState = getCookieState() || {}
          const result = this.getUpdateTipsModel()
          if (!result) return
          this.tipsModel = !Object.keys(cookieState).length
        }
      },
      // 监听页面底部<cookie声明、设置> 打开弹层
      openCookies(newVal) {
        this.settingModel = newVal
      },
      // 监听 cookie setting弹层状态实现 勾选状态记录
      settingModel(newVal) {
        const cookieState = getCookieState() || {}
        const { part = [] } = cookieState

        if (!newVal) {
          this.setOpenCookies(false)
          return
        }

        if (part && part.length) {
          this.filterCookieList = this.filterCookieList.map((item) => {
            const items = part.find((_item) => _item === item.type)
            if (items) {
              item.switchModel = true
            }
            return item
          })
        }
      },
    },
    created() {},
    mounted() {
      Message.receive((res) => {
        const { id } = res || {}
        if (id === popup_id) {
          this.showCookiePopup = true
          PQ.open(popup_id)
        }
      })
      this.init()
    },

    beforeDestroy() {},

    methods: {
      ...mapMutations(['setOpenCookies', 'setCookieAction', 'setCuntryCookie']),

      init() {
        this.defaultSetCountry()
        this.isAcceptAll()
        this.isCookieExpired()
        this.onFilterCookieList()
        this.isCookiePolicyPage()
        dynamicLoadingSDK()
      },

      // 国家是否显示cookie功能
      defaultSetCountry() {
        const result = initCuntryCookieState()
        this.setCuntryCookie(result)
      },

      // 返回 cookie 设置 settings 标题本地化
      settingsLayerTitleMsg(type) {
        const data = {
          0: this.$t('cookie-privacy.cookie_settings_required_type'),
          2: this.$t('cookie-privacy.cookie_settings_advertising_type'),
          3: this.$t('cookie-privacy.cookie_settings_analytical_type'),
        }
        return data[type] || ''
      },
      //  返回 cookie 设置 settings describe本地化
      settingsLayerDescMsg(type) {
        const data = {
          0: this.$t('cookie-privacy.cookie_settings_required_describe'),
          2: this.$t('cookie-privacy.cookie_settings_advertising_describe'),
          3: this.$t('cookie-privacy.cookie_settings_analytical_describe'),
        }
        return data[type] || ''
      },

      // 关闭所有弹层
      closeAllModel() {
        this.settingModel = false
        this.tipsModel = false
        PQ.close(popup_id)
        this.showCookiePopup = false
      },

      // 当前是cookiePolicy 不显示
      isCookiePolicyPage() {
        const { name } = this.$route
        if (name && name === 'cookiePolicy') {
          this.closeAllModel()
        }
      },

      // 判断本地是否有【全部同意】标识
      isAcceptAll() {
        if (this.isApp) {
          return
        }
        const cookieState = getCookieState() || {}
        const { type = '' } = cookieState
        const result = this.getUpdateTipsModel()
        if (!result) return

        this.tipsModel = !(type && cookieArrs.includes(type))
      },

      // 本地cookie状态是否过期
      isCookieExpired() {
        if (this.isApp) {
          return
        }
        const callerTime = Date.now()
        const cookieState = getCookieState() || {}
        const { time = '' } = cookieState

        const result = this.getUpdateTipsModel()
        if (!result) return

        // 已过期
        if (time && callerTime - time > cookieExpiresTime) {
          this.tipsModel = true
          removeCookieState()
        }
      },

      // 传入的settings 列表指定替换
      onFilterCookieList() {
        this.filterCookieList =
          _defaultCookieList.filter((item) =>
            this.cookieList.find((_item) => _item.type === item.type)
          ) || []
      },

      // 【H5 onClick】跳转cookie的政策详情页面说明
      onCookieHandlePolicyUrl() {
        const _location = window && window.location
        if (this.isDesktop) {
          const url = `${_location.origin}${
            _location.pathname === '/' ? '' : _location.pathname
          }/cookiePolicy`
          jumpToPage(url, 'open', '_blank')
          return
        } else {
          this.closeAllModel()
          this.$router_push({
            path: `/cookiePolicy`,
          })
        }
      },

      // 定义公共数据
      setCookieStorage({ type = 'all', time = Date.now(), part = [] } = {}) {
        const data = {
          type,
          time,
          part,
        }

        setCookieState(data)
        this.setOpenCookies(false)
      },

      // 更新cookie的状态
      updateCookieState(type = 'all') {
        let part = []
        this.filterCookieList.forEach((item) => {
          if (!item.allow) {
            // 全部拒绝
            if (type === 'RejectAll') {
              item.switchModel = false
              part = []
            }

            // 全部同意
            if (type === 'all') {
              item.switchModel = true
              part.push(item.type)
            }
          }
        })
        return part
      },

      // 全部同意
      async onAcceptAll() {
        const part = this.updateCookieState()
        this.setCookieStorage({ part })
        this.closeAllModel()
        this.setCookieAction(1)
        this.$emit('onAcceptAll')
        dynamicLoadingSDK()
      },

      // 全部拒绝
      async onRejectAll() {
        this.closeAllModel()
        const part = this.updateCookieState('RejectAll')
        this.setCookieStorage({ type: 'RejectAll', part })
        this.setCookieAction(3)
        this.$emit('onRejectAll')
        dynamicLoadingSDK()
      },

      // 部分同意
      async onCommitPreferences() {
        const filterList = this.filterCookieList.filter(
          (item) => !item.allow && item.switchModel
        )
        const partArrs = filterList.length
          ? filterList.map((item) => item.type)
          : []
        this.setCookieAction(2)
        this.closeAllModel()
        this.setCookieStorage({ type: 'Preferences', part: partArrs })
        this.$emit('onCommitPreferences', partArrs)
        dynamicLoadingSDK()
      },

      // 根据国家是否开放、更新弹层的显示状态
      getUpdateTipsModel() {
        if (!this.isCuntryCookie) {
          this.tipsModel = false
          return false
        }
        return true
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
